import type { ReactNode } from "react";
import { AlertCircle, Check, Info } from "lucide-react";

import { AuthBrandMark } from "@/components/auth/AuthBrandMark";

interface AuthStatusScreenProps {
  /** Visual state. `loading` shows a spinner; others show a tinted icon. */
  state: "loading" | "info" | "success" | "error";
  title?: ReactNode;
  message?: ReactNode;
  /** Buttons / links rendered below the message. Pass via the shared
   * `fx-auth-btn` classes so the styling stays consistent with the rest
   * of the auth shell. */
  action?: ReactNode;
}

export function AuthStatusScreen({
  state,
  title,
  message,
  action,
}: AuthStatusScreenProps): JSX.Element {
  return (
    <div
      className="fx-auth-stage fx-auth-status"
      role={state === "error" ? "alert" : "status"}
      aria-live="polite"
    >
      <div className="fx-auth-status-inner">
        <AuthBrandMark />
        {state === "loading" ? (
          <div className="fx-auth-status-spinner" aria-hidden />
        ) : (
          <div className={`fx-auth-status-icon ${state}`} aria-hidden>
            {state === "info" && <Info />}
            {state === "success" && <Check />}
            {state === "error" && <AlertCircle />}
          </div>
        )}
        {title ? <h1 className="fx-auth-status-title">{title}</h1> : null}
        {message ? <p className="fx-auth-status-message">{message}</p> : null}
        {action ? <div className="fx-auth-status-action">{action}</div> : null}
      </div>
    </div>
  );
}
